import {Theme} from '@material-ui/core'

export const styles = (theme: Theme) => ({
  container: {
    display: 'flex',
    gap: '18px',
    height: '100%',
    border: '1px solid #f1f5f9',
    backgroundColor: 'transparent',
    padding: '20px',
    overflow: 'hidden',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.04), 0 4px 16px 0 rgba(0, 0, 0, 0.08)',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: '#FFF8E1',
    color: '#FF9800',
    fontSize: '15px'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    gap: '8px',
  },
  contentTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize: '18px',
    fontWeight: 300,
    lineHeight: 1.75,
  },
  contentSubTitle: {
    display: 'flex',
    flexDirection:'column',
    gap: '8px',
  },
  pendingBackground: {
    backgroundColor: '#FFF8E1',
  },
  pendingText: {
    color: '#FF9800',
  },
  openIcon: {
    width: '16px',
    height: '16px',
    marginLeft: '8px',
  },
  underline: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
    margin: '10px 0 10px 0',
  },
  relatedAccountContainer: {
    display: 'flex',
  },
  relatedAccountBalance: {
    marginLeft: 'auto',
  },
  relatedAccountLink: {
    color: '#007AFF',
    textDecoration: 'underline',
    cursor: 'pointer',
    marginLeft: 'auto',
    textAlign: 'end',
    transition: 'transform 0.5s',
    '&:hover': {
      transform: 'scale(1.1)',
    }
  },
  status: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  }
}) as const
